import { render, staticRenderFns } from "./InputFileUpdate.vue?vue&type=template&id=0ac22605&scoped=true&"
import script from "./InputFileUpdate.vue?vue&type=script&lang=js&"
export * from "./InputFileUpdate.vue?vue&type=script&lang=js&"
import style0 from "./InputFileUpdate.vue?vue&type=style&index=0&id=0ac22605&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac22605",
  null
  
)

export default component.exports